@for (btn of bannersSocialHeaderButtons; track $index) {
  <button
    mat-icon-button
    class="header-modal-btn"
    [class]="getClassBtn(btn.key)"
    [matTooltip]="btn.tooltipText"
    (click)="handleClick(btn.key)"
  >
    <mat-icon class="header-modal-btn-icon">
      {{ btn.icon }}
    </mat-icon>
  </button>
}
